export const GET_BANNER_LIST = "GET_BANNER_LIST";
export const POST_BANNER = "POST_BANNER";
export const SHOW_BANNER = "SHOW_BANNER";
export const UPDATE_BANNER = "UPDATE_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";
export const UPDATE_STATUS_BANNER = "UPDATE_STATUS_BANNER";
export const GET_CATEGORY = "GET_CATEGORY";
export const DROPDOWN = "BANNER_DROPDOWN";
